<template>
    <section class="content">
      <div>
        <div id="overlay" v-if="loading">
          <div class="spinner"></div>
          <br/>
          <h4>Loading...</h4>
        </div>
        <div class="box box-info">
          <form>
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-2">
                <label for="item">Item </label>
                <AutoComplete v-model="items" filterMatchMode='contains'
                              :suggestions="filteredItems" @complete="searchItem($event)"
                              field="name" ref="itm" :dropdown="true">
                </AutoComplete>
              </div>
              <div class="p-field p-col-12 p-md-2">
                <label for="fromDate">From Date</label>
                <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled"/>
                <input-mask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="fromDate"
                            v-model="fromDate"/>
              </div>
  
              <div class="p-field p-col-12 p-md-2">
                <label for="toDate">To Date</label>
                <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled"/>
                <input-mask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="toDate" v-model="toDate"/>
              </div>
  
              <div class="p-field p-col-12 p-md-1 p-mt-5">
                <Button @click.prevent="searchItemStatement"
                        class="p-button-raised" label="Search" icon="pi pi-search"/>
                <!-- <button type="submit" style="margin-left:10px" v-if="this.inventoryInOutLists.length > 0"  @click.prevent="reset"
                class="btn btn-info pull-left">Reset</button> -->
              </div>
            </div>
          </form>
     
              <DataTable :value="inventoryInOutLists"
                         :paginator="true" ref="po"
                         :rowsPerPageOptions="[100,500,1000]"
                         :rows="100" :filters="filters"
                         class="p-datatable-responsive p-datatable-gridlines"
                         data-key="id">
                         <template #header>
        <div style="text-align: left">
            <Button icon="pi pi-external-link" label="Export" @click="exportCSV($event)" />
        </div>
    </template>
                <Column header="S.N">
                  <template #body="sl">
                    {{ sl.index + 1 }}
                  </template>
                </Column>
                <Column header="Nepali Date" :sortable="true" field="nepaliDate" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['nepaliDate']"/>
                  </template>
                </Column>
                <Column header="Date" :sortable="true" field="date" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['date']"/>
                  </template>
                </Column>
                <Column header="Customer" :sortable="true" field="partyName" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['partyName']"/>
                  </template>
                </Column>
                <Column header="Price" field="price" filterField="price" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['price']"/>
                  </template>
                </Column>
                <Column header="Price With Vat" :sortable="true" field="priceWithVAT" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['priceWithVAT']"/>
                  </template>
                </Column>
            
                <!-- <Column header="Action">
                  <template>
                    <Button icon="pi pi-eye" class="p-button-raised"/>
                  </template>
                </Column> -->
                <template #empty>No record found</template>
              </DataTable>
        </div>
      </div>
    </section>
  </template>
  <script>
  import DatePicker from 'vue2-datepicker'
  import DataTable from 'primevue/datatable'
  import Column from 'primevue/column'
  import Dropdown from 'primevue/dropdown'
//   import globalKey from '../../../store/globalKey'
//   import axios from 'axios'
  import $ from 'jquery'
  import InputText from 'primevue/inputtext'
  import InputMask from 'primevue/inputmask'
  import AutoComplete from 'primevue/autocomplete'
  import Button from 'primevue/button'
  
  export default {
    name: 'ItemPurchaseDetails',
    data() {
      return {
        fromDate: null,
        toDate: null,
        items: '',
        formatted_date: '',
        inventoryInOutLists: [],
        loading: false,
        columnList: '',
        filters: {},
        englishDateEnabled: true,
        filteredItems: null
      }
    },
    mounted() {
      this.itemMasterListByItemTypes()
      this.checkEnglish()
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.nepaliDate()
      }
      if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
        this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      }
      if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
        this.setEnglishDate()
      }
      this.columnNames()
    },
    computed: {
      itemMasterListByItemType() {
        return this.$store.state.itemMaster.itemMasterLists
      }
    },
    methods: {
      async searchItemStatement() {
        if (this.items === '' || this.items === null) {
          this.$toast.add({severity: 'warn', summary: '', detail: 'Please select at least one item!', life: 3000})
          return
        }
        let dat = {
          fromDate: this.fromDate,
          toDate: this.toDate,
          id: this.items.id
        }
        this.loading = true
        let resp = await this.$store.dispatch('loadItemSalesDetailsReport', dat)
        this.loading = false
        this.inventoryInOutLists = resp
      },
      setNepaliDate() {
        if (this.$store.getters.nepaliNewDate !== '') {
          this.fromDate = this.$store.getters.nepaliNewDate
          this.toDate = this.$store.getters.nepaliNewDate
        }
      },
      setEnglishDate() {
        this.fromDate = new Date().toISOString().slice(0, 10)
        this.toDate = new Date().toISOString().slice(0, 10)
      },
      checkEnglish() {
        if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
          this.englishDateEnabled = true
          return
        } else {
          this.englishDateEnabled = false
          return
        }
      },
      nepaliDate() {
        $('#fromDate').nepaliDatePicker({
          ndpYear: true,
          ndpMonth: true,
          ndpYearCount: 10,
          disableBefore: this.$store.state.startDate,
          disableAfter: this.$store.state.endDate,
          onChange: () => {
            this.fromDate = $('#fromDate').val()
          }
        })
        $('#toDate').nepaliDatePicker({
          ndpYear: true,
          ndpMonth: true,
          ndpYearCount: 10,
          disableBefore: this.$store.state.startDate,
          disableAfter: this.$store.state.endDate,
          onChange: () => {
            this.toDate = $('#toDate').val()
          }
        })
      },
      searchItem(event) {
        setTimeout(() => {
          if (!event.query.trim().length) {
            this.filteredItems = [...this.itemMasterListByItemType]
          } else {
            this.filteredItems = this.itemMasterListByItemType.filter((item) => {
              return item.name.toLowerCase().startsWith(event.query.toLowerCase())
            })
          }
        }, 250)
      },
    //   exportCSV() {
    //     let data = {
    //       fromDate: this.fromDate,
    //       toDate: this.toDate,
    //       columnList: this.columnList,
    //       itemId: this.items.id
    //     }
    //     axios({
    //       url: globalKey + '/fileDownload/excelReportInventory/' + data.itemId + '/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + data.fromDate + '/' + data.toDate + '/Item Statement' + '/' + this.$store.getters.fyId + '/' + data.columnList,
    //       method: 'get',
    //       headers: {'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token},
    //       responseType: 'blob'
    //     }).then((response) => {
    //       const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
    //       const link = document.createElement('a')
    //       const contentDisposition = response.headers['content-disposition']
    //       let fileName = 'itemStatement.xlsx'
    //       if (contentDisposition) {
    //         const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
    //         if (fileNameMatch.length === 2) {
    //           fileName = fileNameMatch[1]
    //         }
    //       }
    //       link.href = url
    //       link.setAttribute('download', fileName)
    //       document.body.appendChild(link)
    //       link.click()
    //       link.remove()
    //       window.URL.revokeObjectURL(url)
    //     })
    //   },
      columnNames() {
        for (let i = 0; i < this.$refs.po.columns.length; i++) {
          this.columnList += this.$refs.po.columns[i].header + ','
        }
      },
      exportCSV() {
        this.$refs.po.exportCSV()
      },
      reset() {
        this.inventoryInOutLists = []
        this.items = ''
        if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
          this.fromDate = this.$store.getters.nepaliNewDate
          this.toDate = this.$store.getters.nepaliNewDate
        } else {
          this.fromDate = new Date().toISOString().slice(0, 10)
          this.toDate = new Date().toISOString().slice(0, 10)
        }
      },
      async itemMasterListByItemTypes() {
        await this.$store.dispatch('loadItemMasterList')
      }
    },
    components: {
      DatePicker,
      DataTable,
      Column,
      Dropdown,
      InputText,
      InputMask,
      AutoComplete,
      Button
    }
  }
  </script>
  <style scoped src="@../../../static/css/purchase.css">
  
  </style>



// WEBPACK FOOTER //
// itemSalesDetails.vue?5e627d8e